import * as React from 'react';
import {observer} from 'mobx-react';
import BuildingBlockHeader from './BuildingBlockHeader';
import BuildingBlockMemoryItemContainer from './BuildingBlockMemoryItemContainer';
import {DiagramInstruction} from '../../../stores/OdtExportStore';
import {stylesheet} from 'typestyle';
import {Channel} from '../../../types/Channel';
import LineChartPreview from './LineChartPreview';
import {
    BuildingBlockType,
    DiagramBuildingBlock,
    MergedBuildingBlockInstructions,
    NamedDateRangeWithPreviewDateRange,
    ReportBuildingBlock,
} from '../../types/Report';
import {DateIdBundle} from '../../stores/ReportEditorStore';

interface DiagramBuildingBlockDroppableProps {
    targetCurrency?: string;
    buildingBlock: DiagramBuildingBlock;
    removeBuildingBlock: (idBlock: string) => void;
    removeDiagramTraitFromBuildingBlock: (idBuildingBlock: string, diagramTrait: DiagramInstruction) => void;
    getMergedBuildingBlockInstructions: (buildingBlock: ReportBuildingBlock) => MergedBuildingBlockInstructions;
    removeTableTraitFromBuildingBlock: (idBuildingBlock: string, traitKey: string, traitToRemove: any) => void;
    getFullChannelForChannelName: (channelName: string) => Channel;
    changeBuildingBlockType: (idBuildingBlock: string, newBlockType: BuildingBlockType) => void;
    namedDateRangePackage: {
        namedDateRanges: NamedDateRangeWithPreviewDateRange[];
        selectedIdNamedDateRange: string;
        selectedIdNamedDateCompareRange?: string;
        changeSelectedNamedDateRange: (idBuildingBlock: string, dateIdBundle: DateIdBundle) => void;
    };
    selectedNamedDateRange?: NamedDateRangeWithPreviewDateRange;
    selectedNamedCompareDateRange?: NamedDateRangeWithPreviewDateRange;
    traitChecks: {
        hasToManyChannels: (reportBlocks: ReportBuildingBlock[]) => boolean;
        hasToManySearches: (reportBlocks: ReportBuildingBlock[]) => boolean;
        hasToManySortings: (reportBlocks: ReportBuildingBlock[]) => boolean;
        reportBuildingBlocksAreEmpty: (buildingBlocks: ReportBuildingBlock[]) => boolean;
        hasSearchProductMixedBuildingBlocks: (reportBlocks: ReportBuildingBlock[]) => boolean;
    };
    removeDiagramCompareTraitFromBuidingBlock: (idBuildingBlock: string) => void;
}

@observer
export default class DiagramBuildingBlockDroppable extends React.Component<DiagramBuildingBlockDroppableProps> {
    private renderDiagramPreview(mergedBuildingBlockInstructions: MergedBuildingBlockInstructions) {
        const {searchDiagrams, productDiagrams} = mergedBuildingBlockInstructions.diagramInstruction
            ? mergedBuildingBlockInstructions.diagramInstruction
            : {searchDiagrams: [], productDiagrams: []};
        if (
            mergedBuildingBlockInstructions.diagramInstruction &&
            this.props.selectedNamedDateRange &&
            (searchDiagrams.length > 0 || productDiagrams.length > 0) &&
            (productDiagrams.length === 0 || searchDiagrams.length === 0)
        ) {
            return (
                <div className={diagramBlockCss.diagramPreviewContainer}>
                    <LineChartPreview
                        targetCurrency={this.props.targetCurrency}
                        dateRange={this.props.selectedNamedDateRange.previewDateRange}
                        compareDateRange={
                            this.props.selectedNamedCompareDateRange ? this.props.selectedNamedCompareDateRange.previewDateRange : undefined
                        }
                        mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                        getFullChannelForChannelName={this.props.getFullChannelForChannelName}
                    />
                </div>
            );
        }
        return null;
    }

    public render() {
        const {removeBuildingBlock, buildingBlock, traitChecks, removeDiagramCompareTraitFromBuidingBlock} = this.props;
        const mergedBuildingBlockInstructions = this.props.getMergedBuildingBlockInstructions(buildingBlock);

        return (
            <div>
                <BuildingBlockHeader
                    namedDateRangePackage={this.props.namedDateRangePackage}
                    idBuildingBlock={this.props.buildingBlock.id}
                    changeBuildingBlockType={this.props.changeBuildingBlockType}
                    removeBuildingBlock={() => removeBuildingBlock(buildingBlock.id)}
                    buildingBlockType={this.props.buildingBlock.blockType}
                />
                {this.renderDiagramPreview(mergedBuildingBlockInstructions)}
                <BuildingBlockMemoryItemContainer
                    traitChecks={traitChecks}
                    idParentBlock={buildingBlock.id}
                    removeDiagramTraitFromBuildingBlock={this.props.removeDiagramTraitFromBuildingBlock}
                    removeTableTraitFromBuildingBlock={this.props.removeTableTraitFromBuildingBlock}
                    buildingBlock={this.props.buildingBlock}
                    mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                    removeDiagramCompareTraitFromBuildingBlock={removeDiagramCompareTraitFromBuidingBlock}
                />
            </div>
        );
    }
}

const diagramBlockCss = stylesheet({
    diagramPreviewContainer: {
        position: 'relative',
        height: 300,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PaperSheetBlocks/DiagramBuildingBlockDroppable.tsx